import React from 'react';
interface ScoreHeatmapProps {
  scores: {
    sales: number;
    marketing: number;
    operations: number;
    hr: number;
    finance: number;
  };
}
export const ScoreHeatmap: React.FC<ScoreHeatmapProps> = ({
  scores
}) => {
  const getScoreColor = (score: number) => {
    if (score >= 80) return 'bg-green-500';
    if (score >= 50) return 'bg-yellow-500';
    return 'bg-red-500';
  };
  const getScoreCategory = (score: number) => {
    if (score >= 80) return 'Healthy';
    if (score >= 50) return 'Needs Improvement';
    return 'Critical';
  };
  return <div className="bg-white rounded-lg border shadow-sm p-6" data-id="element-294">
      <h3 className="text-lg font-bold text-gray-800 mb-4" data-id="element-295">
        Business Function Heatmap
      </h3>
      <div className="space-y-4" data-id="element-296">
        {Object.entries(scores).map(([function_name, score]) => <div key={function_name} className="flex items-center" data-id="element-297">
            <div className="w-24 font-medium text-gray-700 capitalize" data-id="element-298">
              {function_name}
            </div>
            <div className="flex-grow" data-id="element-299">
              <div className="flex items-center" data-id="element-300">
                <div className="w-full bg-gray-200 rounded-full h-4 mr-2" data-id="element-301">
                  <div className={`h-4 rounded-full ${getScoreColor(score)}`} style={{
                width: `${score}%`
              }} data-id="element-302"></div>
                </div>
                <div className="w-12 text-sm font-medium" data-id="element-303">{score}%</div>
              </div>
            </div>
            <div className={`ml-2 px-2 py-1 rounded text-xs font-medium ${score >= 80 ? 'bg-green-100 text-green-800' : score >= 50 ? 'bg-yellow-100 text-yellow-800' : 'bg-red-100 text-red-800'}`} data-id="element-304">
              {getScoreCategory(score)}
            </div>
          </div>)}
      </div>
      <div className="mt-6 flex justify-between text-xs" data-id="element-305">
        <div className="flex items-center" data-id="element-306">
          <div className="w-3 h-3 rounded-full bg-red-500 mr-1" data-id="element-307"></div>
          <span data-id="element-308">Critical (0-49%)</span>
        </div>
        <div className="flex items-center" data-id="element-309">
          <div className="w-3 h-3 rounded-full bg-yellow-500 mr-1" data-id="element-310"></div>
          <span data-id="element-311">Needs Improvement (50-79%)</span>
        </div>
        <div className="flex items-center" data-id="element-312">
          <div className="w-3 h-3 rounded-full bg-green-500 mr-1" data-id="element-313"></div>
          <span data-id="element-314">Healthy (80-100%)</span>
        </div>
      </div>
    </div>;
};